import { useEffect, useState } from 'react';
import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { IUser } from '../../types/user';
import { ListContent } from './list_content';
import { ListHeader } from './list_header';
import { Pagination as ListPagination } from '../pagination/pagination';
import { IPostItem } from '../../types/posts';
import { IListItemProps } from '../../types/list_item_props';
import { StubSearch } from '../stub/stub_search';
import { PageBlocked } from '../page_blocked/page_blocked';
import { isAdminOrModerator } from '../../../app/utils';

interface IProps {
  currentUser: IUser;
  regionId?: string;
  author?: string;
  items: IPostItem[];
  pagesCount: number;
  recordsCount: number;
  searchTag?: string;
  saveScroll(item: IListItemProps): void;
  selectedItem?: IListItemProps;
  listItemClass?: React.ComponentType<any>;
  refreshScroll?(): void;
  scrollComments(): void;
  specialistLink?: string;
  search?: string;
  onLoadMore(page: number): void;
}

export const List: React.FC<IProps> = props => {
  const location = useLocation();
  const { pathname } = location;
  const query = new URLSearchParams(location.search);
  const page = query.get('page') ? parseInt(query.get('page') as string, 10) - 1 : 1;

  const [items, setItems] = useState(props.items);
  const [activePage, setActivePage] = useState(page);
  const [moreButtonPressed, setMoreButtonPressed] = useState(false);
  const [scrollTop, setScrollTop] = useState(false);

  let prevOrdering: string;

  useEffect(() => {
    if (!props.selectedItem) {
      window.scrollTo(0, 0);
    }

    return () => {
      setItems(props.items);
      setActivePage(0);
    };
  }, []);

  useEffect(() => {
    // ToDo
    // if (props.items.length) {
    //   setScrollTop(true);
    //   return;
    // }

    const page = moreButtonPressed ? activePage : query.get('page') ? parseInt(query.get('page') as string, 10) - 1 : 0;
    const newItems = moreButtonPressed ? items.concat(props.items) : props.items;

    if (!moreButtonPressed && query.get('page') && scrollTop && prevOrdering === query.get('ordering')) {
      window.scrollTo(0, 0);
    }

    if (prevOrdering !== query.get('ordering')) {
      setScrollTop(false);
      prevOrdering = query.get('ordering') || '-date_publish';
    }

    setItems(newItems);
    setActivePage(page);
    setMoreButtonPressed(false);
  }, [props.items]);

  function getMoreItems(page: number) {
    setActivePage(page - 1);
    setMoreButtonPressed(true);
    props.onLoadMore(page);
  }

  const authorType = () => {
    if (query.get('author_id')) {
      return 'author_id';
    } else if (query.get('comment_user_id')) {
      return 'comment_user_id';
    }

    return '';
  };

  const isBlockedPage = () => {
    const { currentUser } = props;
    const { userId, rating } = currentUser;

    return !isAdminOrModerator(currentUser) && (userId === -1 || (rating || 0) < 50) && pathname.includes('specialist');
  };

  const { pagesCount, saveScroll, selectedItem, refreshScroll, currentUser, specialistLink } = props;
  const ordering = query.get('ordering') ? (query.get('ordering') as string) : '-date_publish';
  const authorId = (query.get('author_id') || query.get('comment_user_id')) as string;

  return (
    <div>
      <ListHeader
        searchTag={props.searchTag}
        author={props.author}
        recordsCount={props.recordsCount}
        pathname={pathname}
        ordering={ordering}
        refreshScroll={refreshScroll}
        currentUser={currentUser}
        authorId={authorId}
        specialistLink={specialistLink}
        listType={items.length > 0 ? items[0].type : ''}
        authorType={authorType()}
        search={props.search}
        isBlockedPage={isBlockedPage()}
      />
      {!isBlockedPage() && items.length > 0 && (
        <ListContent
          regionId={props.regionId}
          currentUser={props.currentUser}
          items={items}
          saveScroll={saveScroll}
          selectedItem={selectedItem}
          listItemClass={props.listItemClass}
          pathname={pathname}
          scrollComments={props.scrollComments}
          search={props.search}
          searchTag={props.searchTag}
        />
      )}
      {!!props.search && !items.length && <StubSearch show={true} searchText={props.search} />}
      {isBlockedPage() && <PageBlocked />}
      {pagesCount > 1 && !isBlockedPage() && (
        <ListPagination
          searchTag={props.searchTag}
          pagesCount={pagesCount}
          activePage={activePage}
          search={props.search}
          getMoreItems={(page: number) => getMoreItems(page)}
          showMoreBtn={true}
        />
      )}
    </div>
  );
};
